module.exports = __webpack_public_path__ + "static/media/S2N5-3.d422df60.svg";